import sortBy from 'lodash/sortBy';
import toInteger from 'lodash/toInteger';
import uniqBy from 'lodash/uniqBy';

function filterByZones(prices, listOfZones) {
  return prices.reduce(function(acc, curr) {
    if (listOfZones.indexOf(parseInt(curr.zone_no, 10)) !== -1) {
      acc.push(curr.price_with_fee);
    }
    return acc;
  }, []);
}

/**
 * Returns a sorted list of unique prices,
 * Data in the format:
 * [{
 *     isDisabled: false,
 *     priceData: {...}
 * }]
 */
function sortedUniquePrices(prices) {
  let newPrices = sortBy(uniqBy(prices, x => x.price_with_fee), x =>
    parseFloat(x.price_with_fee, 10)
  );

  return newPrices.map(item => {
    return {
      isDisabled: false,
      priceData: item
    };
  });
}

/**
 * When we have multiple levels or screens it's useful to
 * disable price options that don't currently apply.
 * Data in the format:
 * [{
 *     isDisabled: false,
 *     priceData: {...}
 * }, {
 *     isDisabled: true,
 *     priceData: {...}
 * },]
 */
function activePricesByZones(prices, listOfZones) {
  var filteredPrices = filterByZones(prices, listOfZones.map(toInteger));
  var sortedPrices = sortedUniquePrices(prices);
  let newPrices = sortedPrices.map(function(item) {
    item.isDisabled =
      filteredPrices.indexOf(item.priceData.price_with_fee) === -1
        ? true
        : false;
    return item;
  });
  return newPrices;
}

export default function getAvailablePrices(prices, listOfZones) {
  if (listOfZones) {
    return activePricesByZones(prices, listOfZones);
  } else {
    return sortedUniquePrices(prices);
  }
}



// WEBPACK FOOTER //
// ./src/javascripts/app/lib/pricing/getAvailablePrices.js